import * as React from 'react';
import * as ReactDOM from 'react-dom';
import {Action, isType, actionCreatorFactory} from "diy/redux/helper";
const actionCreator = actionCreatorFactory('diy/module/section/loadingMask');
import { Store } from "redux";
import { connect, Provider} from "react-redux";

import {AppState} from 'diy/redux/app/state';
import LoadingMask, {LoadingMaskProps} from './components/LoadingMask';

interface ToggleLoadingMaskPayload {
    active: boolean;
}
export const toggleLoadingMask = actionCreator<ToggleLoadingMaskPayload>(
    "MODULE_SECTION_LOADINGMASK_TOGGLE_LOADING_MASK"
);

export function reducer(loadingMask = false, action: Action<any>): boolean {
    if (isType(action, toggleLoadingMask)) {
        return action.payload.active;
    }

    return loadingMask;
}

const mapStateToProps = (appState: AppState) => ({
    visible: appState.moduleSection.loadingMask,
} as LoadingMaskProps);

export function render(store: Store) {
    let maskContainer = document.createElement('div');
    maskContainer.setAttribute('id', 'diy-loading-mask');
    document.body.appendChild(maskContainer);

    const ConnectedLoadingMask = connect(mapStateToProps)(LoadingMask);

    ReactDOM.render(
        <Provider store={store}>
            <ConnectedLoadingMask/>
        </Provider>,
        maskContainer
    );
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/module/section/loadingMask.tsx
 **/